import all from "./all.js";

const dataObj = {
  all,
};
const flattenObject = (obj, res = {}, pk = "") => {
  Object.entries(obj).forEach(([k, v]) => {
    if (typeof v === "object") {
      flattenObject(v, res, `${pk}.${k}`);
    } else {
      res[`${pk}.${k}`] = v;
    }
  });
  return res;
};
const allData = {};
Object.entries(dataObj).forEach(([ns, nsData]) => {
  flattenObject(nsData, allData, ns);
});

export default allData;
